import { createRef, useEffect, useState } from "react";
import "../css/Dashboard.css";
import { Password } from "primereact/password";
import { Divider } from "primereact/divider";
import { InputText } from "primereact/inputtext";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { classNames } from "primereact/utils";
import { InputMask } from "primereact/inputmask";
import { renderToStaticMarkup } from "react-dom/server";
import { Toast } from "primereact/toast";
import { apiClient } from "../apiClient";
import colors from '../colors';
import AccountTutorial from "./Tutorial/AccountTutorial";
import { useTutorial } from '../context/AccountTutorialContext';
import { useOnlineStatus } from "../context/OnlineContext";



function ManageAccount(props)
{

    
    let user = localStorage.getItem('seo_app')? JSON.parse(localStorage.getItem('seo_app')): { username: "", name: "", avatarPic: "profile-index.png" };
    const [fetchedUser, setFetchedUser] = useState(user);
    const { accountTutorialSeen , setAccountTutorialSeen} = useOnlineStatus();
    const [showEmail, setShowEmail] = useState(true);
    const [showPhone, setShowPhone] = useState(false);
    const [showName, setShowName] = useState(true);
    const [showFamilyName, setShowFamilyName] = useState(true);
    const [showWebsite, setShowWebsite] = useState(true);
    const [showPass, setShowPass] = useState(false);
    const token = JSON.parse(localStorage.getItem('userToken'));
    const config = {  headers: {"Content-Type": "application/json",Authorization: `Bearer ${token}`} };
    const [passwordsDoesnotMatch,setPasswordsDoesnotMatch] = useState(false);
    const [changePassResponse,setChangePassResponse] = useState("");
    const [profileUpdated, setProfileUpdated] = useState(0);
    const toast = createRef();
    
   
    

  

    //fetch user data:
    useEffect(() => {

      async function fetchUserData() {
      try {
          const result = await apiClient.get(`${process.env.REACT_APP_BACK}/users/profile/${props.user_id}`,config);
          if (result.status === 200) {
          setFetchedUser(result.data);
          websiteForm.setFieldValue("website",result.data.website);
          emailForm.setFieldValue("email",result.data.email);
          phoneForm.setFieldValue("phone",result.data.phone);
          nameForm.setFieldValue("name",result.data.name);
          familyNameForm.setFieldValue("familyName",result.data.familyName);
          
          }
      } catch (error) {
          console.error(error);
          
      }
      }
   
      fetchUserData();

  }, [profileUpdated]);
    

    const isEmailFormFieldValid = (name) =>
        !!(emailForm.touched[name] && emailForm.errors[name]);
      
    const getEmailFormErrorMessage = (name) => {
        return (
          isEmailFormFieldValid(name) && (
            <small  style={{float:"right"}} className="p-error">{emailForm.errors[name]}</small>
          )
        );
      };

      const isWebsiteFormFieldValid = (name) =>
        !!(websiteForm.touched[name] && websiteForm.errors[name]);
      
      const getWebsiteFormErrorMessage = (name) => {
        return (
          isWebsiteFormFieldValid(name) && (
            <small  style={{float:"right"}} className="p-error">{websiteForm.errors[name]}</small>
          )
        );
      };


      
    // phone form:
const phoneForm = useFormik({
    initialValues: {
      phone: "",
    },
  
    onSubmit: (values) => {
  
  
      const obj = {};
  
      for (const key in values) {
  
        if(values[key] != "")
          obj[key] = values.phone.replace(/[^0-9]+/g, "")
  
        
    }
  
  
      const data = JSON.stringify(obj);
   
    apiClient.patch(process.env.REACT_APP_BACK+"/users/update-phone/"+fetchedUser["_id"], data, config)
        .then(response => {
  
          if(response.status == 200)
          console.log(response)
          setProfileUpdated(profileUpdated+1)
        })
        .catch(error => {
           console.log(error);
          
        });
  
        setShowPhone(false)
      
    },
  });
  
  //name form:
  const nameForm = useFormik({
    initialValues: {
      name: "",
    },
  
    onSubmit: (values) => {
  
  
      const obj = {};
  
      for (const key in values) {
  
        if(values[key] != "")
          obj[key] = values[key];
        
    }
  
  
      const data = JSON.stringify(obj);
   
    apiClient.patch(process.env.REACT_APP_BACK+"/users/update-profile/"+fetchedUser["_id"], data, config)
        .then(response => {
  
          if(response.status == 200)
          
          setProfileUpdated(profileUpdated+1)

          //update local storage:
          user.name=values.name;
          localStorage.setItem("seo_app", JSON.stringify(user));


        })
        .catch(error => {
           console.log(error);
        
        });
  
        setShowName(false)
      
    },
  });

  //family name form:
  const familyNameForm = useFormik({
    initialValues: {
      familyName: "",
    },
  
    onSubmit: (values) => {
  
  
      const obj = {};
  
      for (const key in values) {
  
        if(values[key] != "")
          obj[key] = values[key];
        
    }
  
  
      const data = JSON.stringify(obj);
   
    apiClient.patch(process.env.REACT_APP_BACK+"/users/update-profile/"+fetchedUser["_id"], data, config)
        .then(response => {
  
          if(response.status == 200)
          console.log(response)
          setProfileUpdated(profileUpdated+1)
        })
        .catch(error => {
           console.log(error);
          
        });
  
        setShowFamilyName(false)
      
    },
  });
  

  // password form:
  const passForm = useFormik({
    initialValues: {
      password: "",
      passConfirm:""
    },
  
    onSubmit: (values) => {
  
      if(values["password"] != values["passConfirm"])
      {
        setPasswordsDoesnotMatch(true);
      }
      else
      {
        setPasswordsDoesnotMatch(false);
  
      const obj = {};
  
      for (const key in values) {
  
        if(values[key] != "")
        {
          if(key == "password" || key == "oldPass")
            obj[key] = values[key];
  
        }
        
    }
  
  
      const data = JSON.stringify(obj);
      setChangePassResponse("");
  
    apiClient.patch(process.env.REACT_APP_BACK+"/users/update-pass/"+fetchedUser["_id"], data, config)
        .then(response => {
  
  
          if(response.status == 200)
          {
            if(response.data.status == 403)
            {
              setChangePassResponse(response.data.message);
            }
            else{
              toast.current.show({
                severity: "success",
                
                detail: "رمز با موفقیت تغییر یافت",
              });
          setProfileUpdated(profileUpdated+1);
          setShowPass(false)
          passForm.resetForm();
            }
          }
          
        })
        .catch(error => {
          console.log(error);
         
        });
  
      
      }
    },
  });

  //email form:
  const emailForm = useFormik({
    initialValues: {
      email: "",
    },

    validate: (values) => {
      let errors = {};

      if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
      ) {
        errors.email = "فرمت ایمیل نادرست است";
      }


      return errors;
    },
    onSubmit: (values) => {


      const obj = {};

      for (const key in values) {

        if(values[key] != "")
          obj[key] = values[key];
        
    }


      const data = JSON.stringify(obj);
   
    apiClient.patch(process.env.REACT_APP_BACK+"/users/update-profile/"+fetchedUser["_id"], data, config)
        .then(response => {

          if(response.status == 200)
          console.log(response)
          setProfileUpdated(profileUpdated+1)
        })
        .catch(error => {
           console.log(error);
          
        });

        setShowEmail(false)
      
    },
  });

  


  // website form:
  const websiteForm = useFormik({
    initialValues: {
      website: "",
    },

    validate: (values) => {
      let errors = {};

      if (
        !/^[A-Z0-9._%+-]+\.[A-Z]{2,4}$/i.test(values.website)
      ) {
        errors.website = "فرمت آدرس سایت نادرست است";
      }


      return errors;
    },
    onSubmit: (values) => {


      const obj = {};

      for (const key in values) {

        if(values[key] != "")
          obj[key] = values[key];
        
    }


      const data = JSON.stringify(obj);
   
    apiClient.patch(process.env.REACT_APP_BACK+"/users/update-profile/"+fetchedUser["_id"], data, config)
        .then(response => {

          setShowWebsite(false);


       

          if(response.status == 200)
          console.log(response)
          setProfileUpdated(profileUpdated+1)
        })
        .catch(error => {
           console.log(error);
      
        });

        setShowWebsite(false)
      
    },
  });

   // website login form:
  const websiteLoginForm = useFormik({
    initialValues: {
      websiteUsername: "",
      websitePass: "",
    },

    validate: (values) => {
      let errors = {};

      

      return errors;
    },
    onSubmit: (values) => {


      const obj = {};

      for (const key in values) {

        if(values[key] != "")
          obj[key] = values[key];
        
    }


      const data = JSON.stringify(obj);
   
    apiClient.patch(process.env.REACT_APP_BACK+"/users/update-profile/"+fetchedUser["_id"], data, config)
        .then(response => {

          setShowWebsite(false);


       

          if(response.status == 200)
          console.log(response)
          setProfileUpdated(profileUpdated+1)
        })
        .catch(error => {
           console.log(error);
      
        });

        setShowWebsite(false)
      
    },
  });

   //set tutorialSeen to true:
   const SaveAccountTutorialSeen = (seen) =>
    {
      const data = {accountTutorialSeen:seen};
  
      apiClient.patch(process.env.REACT_APP_BACK+"/users/update-profile/"+user?._id,data,config)
          .then((response) => {
            
            if (response.status == 202)
            {
              setAccountTutorialSeen(seen);
            }
            
          })
          .catch((error) => {
            console.log("axios error");
       
          });
    }

    return(
        <div id="manage-pages">

          {!accountTutorialSeen && <AccountTutorial SaveAccountTutorialSeen={SaveAccountTutorialSeen}></AccountTutorial>}

        <Toast ref={toast} position="center"></Toast>


            <h2>
            اطلاعات کاربری
            </h2>

            
          

          <div id="settings" >
          
          <div className="settings-box account1" >
            <div>

{/* website: */}
            <span>
              <span
                className="settings-row"
                onClick={() => setShowWebsite(!showWebsite)}
              >
                <span className="settings-col1">
                  <i className="pi pi-desktop"></i>
                </span>
                <span className="settings-col2">اطلاعات سایت </span>
                <span className="settings-col3">
                  {!showWebsite ? fetchedUser["website"] : ""}
                </span>
                <span className="settings-col4">
                  <i className="pi pi-angle-down"></i>
                </span>
              </span>

              <span
                id="row1-detail"
                style={{
               
                  overflow: "hidden",   
                  transition: "all .5s ease-in-out",
                  padding: showWebsite ? "20px 0px 10px 0px" : "0px",
                  direction: "rtl",
                  height: showWebsite ? "130px" : "0px",
                  display: "flex",
                }}
              >
                <span style={{ display: "flex", width: "5%" }}></span>
                <span style={{ display: "flex", width: "90%" }}>
                  
                  <form  onSubmit={websiteForm.handleSubmit} style={{ width: "100%" }}>
                    <div>
                      <span className="settings-col2">آدرس سایت  </span>
                      <InputText
                      id="website"
                      name="website"
                      value={websiteForm.values.website}
                      onChange={websiteForm.handleChange}
                        style={{ width: "100%", textAlign: "left" }}
                        placeholder= {fetchedUser["website"]}
                        className={classNames({
                          "p-invalid": isWebsiteFormFieldValid("website"),
                        })}
                        
                      ></InputText>
                      {getWebsiteFormErrorMessage("website")}
                    </div>
                    <div
                      style={{ textAlign: "left", padding: "20px 0px 0px 0px" }}
                    >
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowWebsite(false)}
                      >
                        انصراف
                      </span>
                      <span>
                        <button
                          type="submit"
                          style={{ marginRight: "10px", cursor: "pointer" }}
                        >
                          تایید
                        </button>
                      </span>
                    </div>
                  </form>
                </span>
              </span>

              <span
                id="row1-detail"
                style={{
               
                  overflow: "hidden",   
                  transition: "all .5s ease-in-out",
                  padding: showWebsite ? "20px 0px 10px 0px" : "0px",
                  direction: "rtl",
                  height: showWebsite ? "180px" : "0px",
                  display: "flex",
                }}
              >
                <span style={{ display: "flex", width: "5%" }}></span>
                <span style={{ display: "flex", width: "90%"}}>
                  
                  <form  onSubmit={websiteLoginForm.handleSubmit} style={{ width: "100%"}}>

                    <span className="settings-col2" style={{width:'100%',fontWeight:'bolder',marginBottom:'10px'}}>
                      <pi className="pi pi-info-circle" style={{color:colors.primary,marginLeft:'5px'}}></pi>
                      اگر می خواهید مقاله شما بصورت خودکار داخل وبسایت وردپرسی تان منتشر شود، لطفا اطلاعات ورود کاربری   را وارد کنید. برای راهنمایی بیشتر، 
                      
                      <a style={{marginLeft:'5px',marginRight:'5px',textDecoration:'underline',color:colors.primary}}>اینجا</a>
                      را بخوانید.</span>

                    <div  style={{ width: "100%",display:'flex',flexDirection:'row',gap:'30px' }}>

                    <div style={{display:'flex', width:'50%',flexDirection:'column'}}>
                      <span className="settings-col2">نام کاربری </span>
                      <InputText
                      id="website"
                      name="website"
                      value={websiteLoginForm.values.websiteUsername}
                      onChange={websiteLoginForm.handleChange}
                        style={{ width: "100%", textAlign: "left" }}
                        placeholder= {fetchedUser["websiteUsername"]}
                        className={classNames({
                          "p-invalid": isWebsiteFormFieldValid("website"),
                        })}
                        
                      ></InputText>
                      {getWebsiteFormErrorMessage("website")}
                    </div>

                    <div style={{display:'flex', width:'50%',flexDirection:'column'}}>
                      <span className="settings-col2">رمز عبور </span>
                      <Password
                      id="website"
                      name="website"
                      value={websiteLoginForm.values.websitePass}
                      onChange={websiteLoginForm.handleChange}
                        style={{ width: "100%", textAlign: "left" }}
                        placeholder= {fetchedUser["websitePass"]}
                        className={classNames({
                          "p-invalid": isWebsiteFormFieldValid("website"),
                        })}
                        
                      ></Password>
                      {getWebsiteFormErrorMessage("website")}
                    </div>


                    </div>



                    <div
                      style={{ textAlign: "left", padding: "20px 0px 0px 0px" }}
                    >
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowWebsite(false)}
                      >
                        انصراف
                      </span>
                      <span>
                        <button
                          type="submit"
                          style={{ marginRight: "10px", cursor: "pointer" }}
                        >
                          تایید
                        </button>
                      </span>
                    </div>
                  </form>
                </span>
              </span>


            

            </span>


            

              <Divider></Divider>

{/* email: */}
          <span className="account2">

              <span
                className="settings-row"
                onClick={() => setShowEmail(!showEmail)}
              >
                <span className="settings-col1">
                  <i className="pi pi-envelope"></i>
                </span>
                <span className="settings-col2">آدرس ایمیل</span>
                <span className="settings-col3">
                  {!showEmail ? fetchedUser["email"] : ""}
                </span>
                <span className="settings-col4">
                  <i className="pi pi-angle-down"></i>
                </span>
              </span>

              <span
                id="row1-detail"
                style={{
               
                  overflow: "hidden",   
                  transition: "all .5s ease-in-out",
                  padding: showEmail ? "20px 0px 10px 0px" : "0px",
                  direction: "rtl",
                  height: showEmail ? "120px" : "0px",
                  display: "flex",
                }}
              >
                <span style={{ display: "flex", width: "5%" }}></span>
                <span style={{ display: "flex", width: "90%" }}>
                  
                  <form  onSubmit={emailForm.handleSubmit} style={{ width: "100%" }}>
                    <div>
                      <InputText
                      id="email"
                      name="email"
                      value={emailForm.values.email}
                      onChange={emailForm.handleChange}
                        style={{ width: "100%", textAlign: "left" }}
                        placeholder= {"آدرس ایمیل خود را وارد کنید"}
                        className={classNames({
                          "p-invalid": isEmailFormFieldValid("email"),
                        })}
                        
                      ></InputText>
                      {getEmailFormErrorMessage("email")}
                    </div>
                    <div
                      style={{ textAlign: "left", padding: "20px 0px 0px 0px" }}
                    >
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowEmail(false)}
                      >
                        انصراف
                      </span>
                      <span>
                        <button
                          type="submit"
                          style={{ marginRight: "10px", cursor: "pointer" }}
                        >
                          تایید
                        </button>
                      </span>
                    </div>
                  </form>
                </span>
              </span>

              <Divider></Divider>

          </span>

{/* phone: */}

          
              <span
                className="settings-row"
                onClick={() => setShowPhone(!showPhone)}
              >
                <span className="settings-col1">
                  <i className="pi pi-phone"></i>
                </span>
                <span className="settings-col2">شماره تلفن همراه</span>
                <span className="settings-col3">
                  {!showPhone ? fetchedUser["phone"] : ""}
                </span>
                <span className="settings-col4">
                  <i className="pi pi-angle-down"></i>
                </span>
              </span>

              <span
                id="row2-detail"
                style={{
                  overflow: "hidden",   
                  transition: "all .5s ease-in-out",
                  padding: showPhone ? "20px 0px 10px 0px" : "0px",
                  direction: "rtl",
                  height: showPhone ? "120px" : "0px",
                  display: "flex",
                }}
              >
                <span style={{ display: "flex", width: "5%" }}></span>
                <span style={{ display: "flex", width: "90%" }}>
                  
                  <form onSubmit={phoneForm.handleSubmit} style={{ width: "100%" }}>
                    <div>
                      <InputMask
                      id="phone"
                      name="phone"
                      mask="(0999) 999-99-99"
                      value={phoneForm.values.phone}
                      onChange={phoneForm.handleChange}
                        style={{ width: "100%", direction: "ltr", textAlign: "left"}}
                        placeholder= {"شماره تلفن همراه خود را وارد کنید"}
                      ></InputMask>

                    </div>
                    <div
                      style={{ textAlign: "left", padding: "20px 0px 0px 0px" }}
                    >
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowPhone(false)}
                      >
                        انصراف
                      </span>
                      <span>
                        <button
                          type="submit"
                          style={{ marginRight: "10px", cursor: "pointer" }}
                        >
                          تایید
                        </button>
                      </span>
                    </div>
                    
                  </form>
                </span>
              </span>

              <Divider></Divider>

          


{/* name: */}

          <span className="account3">

              <span
                className="settings-row"
                onClick={() => setShowName(!showName)}
              >
                <span className="settings-col1">
                  <i className="pi pi-id-card"></i>
                </span>
                <span className="settings-col2">نام </span>
                <span className="settings-col3">
                  {!showName ? fetchedUser["name"] : ""}
                </span>
                <span className="settings-col4">
                  <i className="pi pi-angle-down"></i>
                </span>
              </span>
              <span
                id="row3-detail"
                style={{
                  overflow: "hidden",   
                  transition: "all .5s ease-in-out",
                  padding: showName ? "20px 0px 10px 0px" : "0px",
                  direction: "rtl",
                  height: showName ? "120px" : "0px",
                  display: "flex",
                }}
              >
                <span style={{ display: "flex", width: "5%" }}></span>
                <span style={{ display: "flex", width: "90%" }}>
                  
                  <form onSubmit={nameForm.handleSubmit} style={{ width: "100%" }}>
                    <div>
                      <InputText
                      id="name"
                      name="name"
                      value={nameForm.values.name}
                      onChange={nameForm.handleChange}
                        style={{ width: "100%", textAlign: "right" }}
                        placeholder= {"نام خو د را وارد کنید"}              
                      ></InputText>
                    </div>

                    <div
                      style={{ textAlign: "left", padding: "20px 0px 0px 0px" }}
                    >
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowName(false)}
                      >
                        انصراف
                      </span>
                      <span>
                        <button
                          type="submit"
                          style={{ marginRight: "10px", cursor: "pointer" }}
                        >
                          تایید
                        </button>
                      </span>
                    </div>
                 
                  </form>
                </span>
              </span>
         

            <Divider></Divider>
            </span>

  {/* family name: */}

          <span className="account4">
              
              <span
                className="settings-row"
                onClick={() => setShowFamilyName(!showFamilyName)}
              >
                <span className="settings-col1">
                  <i className="pi pi-id-card"></i>
                </span>
                <span className="settings-col2">نام خانوادگی </span>
                <span className="settings-col3">
                  {!showFamilyName ? fetchedUser["familyName"] : ""}
                </span>
                <span className="settings-col4">
                  <i className="pi pi-angle-down"></i>
                </span>
              </span>
              <span
                id="row3-detail"
                style={{
                  overflow: "hidden",   
                  transition: "all .5s ease-in-out",
                  padding: showFamilyName ? "20px 0px 10px 0px" : "0px",
                  direction: "rtl",
                  height: showFamilyName ? "120px" : "0px",
                  display: "flex",
                }}
              >
                <span style={{ display: "flex", width: "5%" }}></span>
                <span style={{ display: "flex", width: "90%" }}>
                  
                  <form onSubmit={familyNameForm.handleSubmit} style={{ width: "100%" }}>
                    <div>
                      <InputText
                      id="familyName"
                      name="familyName"
                      value={familyNameForm.values.familyName}
                      onChange={familyNameForm.handleChange}
                        style={{ width: "100%", textAlign: "right" }}
                        placeholder= {"نام خانوادگی خود را وارد کنید"}
                      ></InputText>
                    </div>
                    <div
                      style={{ textAlign: "left", padding: "20px 0px 0px 0px" }}
                    >
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowFamilyName(false)}
                      >
                        انصراف
                      </span>
                      <span>
                        <button
                          type="submit"
                          style={{ marginRight: "10px", cursor: "pointer" }}
                        >
                          تایید
                        </button>
                      </span>
                    </div>
                 
                  </form>
                </span>
              </span>

              </span>
      </div>
      </div>



          
{/* password: */}
          <h6>رمز عبور</h6>
          <div className="settings-box">
            <div>
              <span
                className="settings-row"
                onClick={() => setShowPass(!showPass)}
              >
                <span className="settings-col1">
                  <i className="pi pi-lock"></i>
                </span>
                <span className="settings-col2">تغییر رمز عبور</span>
                <span className="settings-col3"></span>
                <span className="settings-col4">
                  <i className="pi pi-angle-down"></i>
                </span>
              </span>
            </div>

            <span
              id="row4-detail"
              style={{
                overflow: "hidden",   
                  transition: "all .5s ease-in-out",
                  padding: showPass ? "20px 0px 10px 0px" : "0px",
                  direction: "rtl",
                  height: showPass ? "250px" : "0px",
                  display: "flex",
              }}
            >
              <span style={{ display: "flex", width: "5%" }}></span>
              <span style={{ display: "flex", width: "90%" }}>
              
                <form onSubmit={passForm.handleSubmit} style={{ width: "100%" }}>
                
                  <div>
                    <Password
                    id="password"
                    name="password"
                    value={passForm.values["password"]}
                    onChange={passForm.handleChange}
                      style={{
                        width: "100%",
                        textAlign: "right",
                        marginBottom: "15px",
                      }}
                      placeholder="رمز عبور جدید"
                    ></Password>
                    
                  </div>
                  <div>
                    <Password
                    id="passConfirm"
                    name="passConfirm"
                    value={passForm.values["passConfirm"]}
                    onChange={passForm.handleChange}
                      style={{
                        width: "100%",
                        textAlign: "right",
                        marginBottom: "15px",
                      }}
                      placeholder="تکرار رمز عبور جدید"
                    ></Password>
                    { passwordsDoesnotMatch ? <small  style={{float:"right"}} className="p-error">رمزهای جدید وارد شده یکسان نیستند</small>: null}
                    { changePassResponse != "" ? <small  style={{float:"right"}} className="p-error">{changePassResponse}</small>: null}
                  </div>
                  <div
                    style={{ textAlign: "left", padding: "20px 0px 0px 0px" }}
                  >
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowPass(false)}
                    >
                      انصراف
                    </span>
                    <span>
                      <button
                        type="submit"
                        style={{ marginRight: "10px", cursor: "pointer" }}
                      >
                        تایید
                      </button>
                    </span>
                  </div>
                </form>
              </span>
            </span>
          </div>

         
          </div>
        

        </div>
    );
}

export default ManageAccount;